export default {
  locale: (state, getters) => `${getters.language}-${getters.country}`,
  language: (state) => state.context.site.language || 'en',
  country: (state) => state.context.site.country || 'GB',
  getDirection: (state) => (['ar', 'he'].indexOf(state.context.site.language) === -1 ? 'ltr' : 'rtl'),
  getUnit: (state) => (!state.context.site.unit.isImperial ? 'km' : 'miles'),
  isKilometer: (state) => !state.context.site.unit.isImperial,
  getCurrencySymbol: (state) => (!state.context.site.currency.symbol ? '£' : state.context.site.currency.symbol),
  getCurrency: (state) => (!state.context.site.currency.intlSymbol ? 'GBP' : state.context.site.currency.intlSymbol),
  getSiteUrl: (state) => (!state.context.site.url ? window.location.origin
    : state.context.site.url),
  getGoogleMapKey: (state) => state.context.site.googleMapKey,
  getPaymentConfigurationId: (state) => state.context.site.gforcesPaymentApiId || '',
  getSiteFranchiseHash: (state) => state.context.site.franchiseHash || '',
  getSiteFranchisePath: (state) => state.context.site.franchisePath || '',
  getSiteGroupHash: (state) => state.context.site.groupHash || '',
  isOwnershipEnabled: (state) => state.context.site.isOwnershipEnabled || false,
  getOwnershipUrl: (state) => state.context.site.ownershipUrl,
  getPrivacyPageUrl: (state) => state.context?.site?.privacyPageUrl || window.location.href,
  getListingUrl: (state) => state.context?.site?.listingUrl,
  getGoogleReviews: (state) => state.context?.site?.googleReviews || [],
};
